import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { AppServiceService } from "../../app/main/services/product.service";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { MainService } from '../../app/main/main.service'
import { HotkeysService, Hotkey } from 'angular2-hotkeys';

export interface Refreshable {
    refresh: () => void;
}
@Component({
    selector: 'appfooter',
    template: require('./footer.html'),
    // styles: [require('./footer.css')]
})

export class FooterComponent implements Refreshable {
    @ViewChild('unitpopup') unitpopup: ElementRef;
    public unitInfo: any;
    Router;
    isLoggedIn;
    AuthService;
    modalReference: NgbModalRef;
    UnitDetails: any;
    unitList: any;
    FyearList: any;
    busy: Subscription;
    ipService:any;
    currentIP:any;
    hotkeyList: any = [];
    hotkeyListModal: any = [];

    static parameters = [HttpClient, AuthService, Router, AppServiceService, NgbModal, MainService, HotkeysService];

    constructor(private http: HttpClient, private authService: AuthService, private router: Router, private _AppServiceService: AppServiceService, private modalService: NgbModal, private mainService: MainService, private hotkeysService: HotkeysService) {
        this.http = http;
        this.Router = router;
        this.AuthService = authService;
        this._AppServiceService = _AppServiceService;
        this.mainService = mainService;
    }

    ngOnInit() {
        this.unitInfo = {};
        this.unitInfo.Company_Name = "";
        this.unitInfo.Fyear = "";
        this.unitInfo.Unit_Name = "";
        this.unitInfo.Unit_GST_No = "";
        //this.reset();
        this._AppServiceService.getFooterDetails();
        setTimeout(() => {
                this._AppServiceService.footerDataTable.subscribe(res => {
                    this.unitInfo = res;
                });
            }, 600);
            this.getPublicIP().subscribe((data: any) => {
            this.currentIP = data.ip;
            console.log("Current IP:", this.currentIP);
        });

        this.InitHotKeys();
    }

    InitHotKeys() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];
        const ctrlshiftb = new Hotkey('ctrl+shift+b', (event: KeyboardEvent): boolean => {
            if (this.modalService.hasOpenModals()) {
                this.modalService.dismissAll('close all to open new popup!');
            }
            this.OpenUnitPopup(this.unitpopup);
            // this.modalReference = this.modalService.open(this.unitpopup, { size: 'sm', windowClass: 'data-show unit-show'});
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);

        this.hotkeyList.push(ctrlshiftb);
        this.hotkeysService.add(ctrlshiftb);

    }

    refresh() {
        // window.location.reload();

    }

    reset() {
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        // this.AuthService.isLoggedIn().then(is => {
        //     this.isLoggedIn = is;
        //     this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        // });
    }

    logout() {
        return this.AuthService.logout().then(() => {
            this.Router.navigateByUrl('/login');
            localStorage.clear();
            this.reset();
        });
    }

    OpenUnitPopup(unitpopup) {
        this.UnitDetails = JSON.parse(localStorage.getItem('permission'))[0];
        let data = { "user_ID": this.UnitDetails._id };
        let list = this._AppServiceService.GetUnitFyearList();
        this.unitList = list.UnitList;
        this.FyearList = list.FYearList;
        setTimeout(() => {
            this.modalReference = this.modalService.open(unitpopup, { size: 'sm', windowClass: 'data-show unit-show' })
        }, 200);
    }

    getSelectedUnit(event) {
        this.unitInfo = event;
        this._AppServiceService.getFooterDetails();
        this.modalReference.close();
        window.location.reload();
    }
    
    onVersionClick(){
        // console.log("Version Clicked"); 
        this.mainService.triggerOpenModal(); // 
    }

    getPublicIP() {
        return this.http.get('https://api.ipify.org?format=json');
    }
}
